import React from 'react';
import { NotificationBadge } from './NotificationBadge';
import { SettingsIcon } from 'lucide-react';
export function Header({
  activeTab = 'home',
  unreadNotifications = 0,
  onNotificationClick,
  onSettingsClick
}) {
  // Define titles for each tab
  const titles = {
    home: "What's the Move",
    saves: 'My Saved Events',
    settings: 'Account',
    profile: 'Edit Profile'
  };
  return <header className="bg-white shadow-sm" data-id="element-299">
      <div className="container mx-auto px-4 py-4 max-w-lg" data-id="element-300">
        <div className="flex justify-between items-center" data-id="element-301">
          <h1 className="text-xl font-bold text-blue-600" data-id="element-302">
            {activeTab === 'home' ? 'wtm' : titles[activeTab]}
          </h1>
          <div className="flex items-center" data-id="element-303">
            {activeTab === 'home' && <p className="text-sm text-gray-600 mr-3" data-id="element-304">What's the Move</p>}
            {activeTab === 'settings' && <button onClick={onSettingsClick} className="p-1 rounded-full hover:bg-gray-100 mr-2" aria-label="Settings" data-id="element-305">
                <SettingsIcon className="w-6 h-6 text-gray-500" data-id="element-306" />
              </button>}
            <NotificationBadge count={unreadNotifications} onClick={onNotificationClick} data-id="element-307" />
          </div>
        </div>
      </div>
    </header>;
}